import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/app/solutions/agriculture/Agriculture.jsx");
